'use client';

import { trackEvent } from '@svs/nova-core/analytics';
import { COUPON_SETTINGS_SHEET } from '@svs/nova-poolbetting/schema/input';
import { TipsenLink } from '@svs/nova-poolbetting/ui/TipsenLink';
import { Button } from '@svs/ui/react/button';
import Settings from '@svs/ui/react/icons/Settings';
import type { ReactNode } from 'react';

const handleTracking = (label: string, pathname: string): void => {
  trackEvent({ category: 'Nya tipsen', action: label, optLabel: pathname });
};

type CouponToolboxSettingsButtonProps = {
  pathname: string;
};

/**
 * Button component for accessing coupon toolbox settings.
 * Tracks user interactions when the settings button is clicked.
 *
 * @param root0 Component props
 * @param root0.pathname The current pathname for tracking purposes
 * @returns A button that links to the coupon settings sheet
 */
export function CouponToolboxSettingsButton({ pathname }: CouponToolboxSettingsButtonProps): ReactNode {
  return (
    <div className="bg-layer-contrast-on-base border-stroke-medium rounded-sm border px-1 py-0.5 lg:h-10 lg:px-0 lg:py-0">
      <Button
        asChild
        variant="ghost"
        className="justify-self-end"
        onClick={() => {
          handleTracking('Inställningar', pathname);
        }}
      >
        <TipsenLink
          href={{
            query: {
              sheet: COUPON_SETTINGS_SHEET,
            },
          }}
          queriesToKeep="ALL"
          scroll={false}
        >
          <Settings />
          Inställningar
        </TipsenLink>
      </Button>
    </div>
  );
}
